/**
 * Chaîne documentaire commerciale : devis, commande, facture.
 * Référence : document 09 § 11.
 *
 * Toutes les sociétés n'émettent pas de bon de commande : le mode retenu dans les paramètres
 * de la société détermine si la phase commande est jouée ou occultée.
 */
/** Modes de chaîne documentaire proposés par société. */
export const DOCUMENT_CHAIN_MODES = ['quote_order_invoice', 'quote_invoice'];
/** Mode par défaut : cycle complet devis → commande → facture. */
export const DEFAULT_DOCUMENT_CHAIN_MODE = 'quote_order_invoice';
/** Libellés des modes, présentés dans l'écran des paramètres société. */
export const DOCUMENT_CHAIN_MODE_LABELS = {
    quote_order_invoice: 'Devis, commande, facture',
    quote_invoice: 'Devis, facture (sans commande)',
};
/** Explication associée à chaque mode, affichée sous le sélecteur. */
export const DOCUMENT_CHAIN_MODE_DESCRIPTIONS = {
    quote_order_invoice: 'Le devis accepte devient une commande, puis la commande livree devient une facture.',
    quote_invoice: 'La phase commande est masquee : le devis accepte est facture directement.',
};
/** Clé des paramètres avancés de la société (`tenants.settings`) portant les réglages documentaires. */
export const DOCUMENT_SETTINGS_KEY = 'documents';
/** Réglages documentaires par défaut d'une société. */
export const DEFAULT_DOCUMENT_SETTINGS = {
    chain: DEFAULT_DOCUMENT_CHAIN_MODE,
};
/** Indique si une valeur inconnue est un mode de chaîne documentaire valide. */
export function isDocumentChainMode(value) {
    return DOCUMENT_CHAIN_MODES.includes(value);
}
/**
 * Résout le mode de chaîne documentaire à partir des paramètres avancés de la société.
 * Une valeur absente ou invalide retombe sur le mode par défaut.
 */
export function resolveDocumentChainMode(settings) {
    const raw = settings?.[DOCUMENT_SETTINGS_KEY];
    if (raw === null || raw === undefined || typeof raw !== 'object') {
        return DEFAULT_DOCUMENT_CHAIN_MODE;
    }
    const chain = raw.chain;
    return isDocumentChainMode(chain) ? chain : DEFAULT_DOCUMENT_CHAIN_MODE;
}
//# sourceMappingURL=documents.constants.js.map